const toastConfig = (paramsOrDescription) => {
  return typeof paramsOrDescription === "string"
    ? {
        description: paramsOrDescription,
      }
    : {
        ...paramsOrDescription,
      };
};

export const success = (params) => ({
  duration: 5000,
  ...toastConfig(params),
  status: "success",
});

export const error = (params) => ({
  duration: null,
  isClosable: true,
  ...toastConfig(params),
  status: "error",
});

export const warning = (params) => ({
  duration: 5000,
  ...toastConfig(params),
  status: "warning",
});

export const info = (params) => ({
  duration: 10000,
  ...toastConfig(params),
  status: "info",
});
